












import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  props: {
    type: {
      type: String,
      required: true,
      validator: (val: string) => ['question', 'article'].includes(val),
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      knowledgeTags: (state: any) => state.treeKnowledges.knowledges,
    }),
  },
  async created() {
    this.$store.commit('CLEAN_KNOWLEDGES');
    if (this.id) {
      await this.$store.dispatch('PULL_KNOWLEDGE_ASSOCIATIONS', {
        type: this.type,
        id: this.id,
      });
    }
  },
});
